import axios from "axios";
import { apiFilesUrl } from "src/common/apiUrl";

export type ImageSize = "large" | "medium" | "small";

export const imgSrc = (uid: string, size: ImageSize = "large") =>
  urlForDownload(true, uid, size);

export const urlForDownload = (
  isImage: boolean,
  uid: string,
  imageSize?: ImageSize,
): string =>
  axios.getUri({
    url: apiFilesUrl(""),
    params: {
      filePath: uid,
      fileType: isImage ? "IMAGE" : undefined,
      imageSize: imageSize?.toUpperCase(),
    },
  });
